module.exports = __webpack_public_path__ + "files/56c57e6d9b27a227368797558258fe3d.png";